import React from 'react';

const Loading = (props) => {
  const cssClass = props.cssClass || '';
  return (
    <div class={cssClass}>
      <i class={`fa fa-spinner fa-spin fa-${props.size}x fa-fw`} />
    </div>
  );
};
export default Loading;
